var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCameraVideo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.24316 8C1.24316 6.48122 2.47438 5.25 3.99316 5.25H13.9932C15.5119 5.25 16.7432 6.48122 16.7432 8V16C16.7432 17.5188 15.5119 18.75 13.9932 18.75H3.99316C2.47438 18.75 1.24316 17.5188 1.24316 16V8ZM3.99316 6.75C3.30281 6.75 2.74316 7.30964 2.74316 8V16C2.74316 16.6904 3.30281 17.25 3.99316 17.25H13.9932C14.6835 17.25 15.2432 16.6904 15.2432 16V8C15.2432 7.30964 14.6835 6.75 13.9932 6.75H3.99316Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.9178 6.38177C23.1215 6.52166 23.2432 6.7529 23.2432 7V17C23.2432 17.2471 23.1215 17.4783 22.9178 17.6182C22.7141 17.7581 22.4546 17.7887 22.2239 17.7L15.7239 15.2C15.4343 15.0886 15.2432 14.8103 15.2432 14.5V9.5C15.2432 9.18967 15.4343 8.91139 15.7239 8.79999L22.2239 6.29999C22.4546 6.21129 22.7141 6.24187 22.9178 6.38177ZM16.7432 10.0151V13.9849L21.7432 15.908V8.09202L16.7432 10.0151Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraVideo);
export default __webpack_public_path__ + "static/media/CameraVideo.45c3c65bfc828b2fab72d8c57c9e8cce.svg";
export { ForwardRef as ReactComponent };